/*
 *  Class Countdown
 */
export
default class Countdown {
    constructor(teaser) {
      this.countdown = teaser.querySelector('.countdown');
      if (!this.countdown) {
        return;
      }
      this.interval = null;
      this.tmpl = {};
      this.start = 0;
      this.init();
    }

    createCountdownTemplate() {
      const titleLabel = document.createElement('span');
      titleLabel.classList.add('teaser__countdown-title-label');
      titleLabel.innerText = this.countdown.getAttribute('data-countdown-title-label');
      const titleValue = document.createElement('span');
      titleValue.classList.add('teaser__countdown-title-value');
      const title = document.createElement('h4');
      title.classList.add('teaser__countdown-title');
      title.appendChild(titleLabel);
      title.appendChild(titleValue);

      const dayLabel = document.createElement('span');
      dayLabel.classList.add('teaser__countdown-element-label');
      dayLabel.innerText = this.countdown.getAttribute('data-countdown-day-label');
      const dayValue = document.createElement('span');
      dayValue.classList.add('teaser__countdown-element-value');
      const day = document.createElement('div');
      day.classList.add('teaser__countdown-element');
      day.appendChild(dayLabel);
      day.appendChild(dayValue);

      const hourLabel = document.createElement('span');
      hourLabel.classList.add('teaser__countdown-element-label');
      hourLabel.innerText = this.countdown.getAttribute('data-countdown-hour-label');
      const hourValue = document.createElement('span');
      hourValue.classList.add('teaser__countdown-element-value');
      const hour = document.createElement('div');
      hour.classList.add('teaser__countdown-element');
      hour.appendChild(hourLabel);
      hour.appendChild(hourValue);

      const minuteLabel = document.createElement('span');
      minuteLabel.classList.add('teaser__countdown-element-label');
      minuteLabel.innerText = this.countdown.getAttribute('data-countdown-minute-label');
      const minuteValue = document.createElement('span');
      minuteValue.classList.add('teaser__countdown-element-value');
      const minute = document.createElement('div');
      minute.classList.add('teaser__countdown-element');
      minute.appendChild(minuteLabel);
      minute.appendChild(minuteValue);

      const secondLabel = document.createElement('span');
      secondLabel.classList.add('teaser__countdown-element-label');
      secondLabel.innerText = this.countdown.getAttribute('data-countdown-second-label');
      const secondValue = document.createElement('span');
      secondValue.classList.add('teaser__countdown-element-value');
      const second = document.createElement('div');
      second.classList.add('teaser__countdown-element');
      second.appendChild(secondLabel);
      second.appendChild(secondValue);

      this.countdown.appendChild(title);

      const countdownElements = document.createElement('div');
      countdownElements.classList.add('teaser__countdown-elements');

      countdownElements.appendChild(day);
      countdownElements.appendChild(hour);
      countdownElements.appendChild(minute);
      countdownElements.appendChild(second);

      this.countdown.appendChild(countdownElements);

      return {
        title: titleValue,
        day: dayValue,
        hour: hourValue,
        minute: minuteValue,
        second: secondValue
      };
    }

    updatePresentation() {
      let timeleft = new Date(this.start - new Date());
      if (0 >= timeleft) {
        timeleft = 0;
        this.hideCountdownTemplate();
        clearInterval(this.interval);
      }

      if (timeleft) {
        const allDays = parseInt(timeleft > 0 ? timeleft / 1000 / 60 / 60 / 24 : 0);
        this.tmpl.day.innerText = allDays;
        // this.tmpl.day.innerText = this.start.getDate(); // Return only the remaining days of a month
        this.tmpl.hour.innerText = this.formatTwoLetterNumber(timeleft.getHours() - 1);
        this.tmpl.minute.innerText = this.formatTwoLetterNumber(timeleft.getMinutes());
        this.tmpl.second.innerText = this.formatTwoLetterNumber(timeleft.getSeconds());
      }
    };

    formatTwoLetterNumber(value) {
      return value > 9 ? value : '0' + value;
    }

    hideCountdownTemplate() {
      this.countdown.classList.add('hidden');
    }

    init() {
      const dateTime = this.countdown.getAttribute('data-countdown-datetime');
      const currentDate = new Date();
      const newDateTime = new Date(dateTime);
      if (!dateTime || (dateTime && newDateTime <= currentDate)) {
        this.hideCountdownTemplate();
        return;
      }

      this.countdown.classList.remove('hidden');
      this.tmpl = this.createCountdownTemplate();
      this.start = new Date(dateTime);
      // this.start.setDate(this.start.getDate() - 1);
      this.start.setHours(this.start.getHours() - 1);

      const titleBody = [
        this.formatTwoLetterNumber(this.start.getDate()),
        this.formatTwoLetterNumber(this.start.getMonth() + 1),
        this.start.getFullYear()
      ];
      this.tmpl.title.innerText = titleBody.join('.');
      this.interval = setInterval(this.updatePresentation.bind(this), 1000);
      this.updatePresentation();
    }

}
